<template>
    <div class="filter">
        <h2 v-if="!hideHeader">{{ $t('title.search') }}</h2>
        <div class="filters">
            <div class=" filterAndButtons">
                <div class="" v-if="this.comparisonListFacture !== undefined">
                    <DropDown
                        :label="$t('label.fournisseur.dropdown.montantttc')"
                        :list="comparisonListFacture"
                        :selectedItem="filter.comparisonFacture"
                        :display="displayType"
                        @select="selectComparisonFacture"
                        class="width-250px"
                    />
                </div>
                <div class='center'>{{$t('facture.montant.a')}}</div>
                <div class="" v-if="this.comparisonListFacture !== undefined">
                    <div class="inputWrap noMarginLeft">
                        <NumberInput
                            class="filterInput"
                            v-model="filterMontant"
                            :label="$t('facture.filter.montantTTC')"
                            :class="filterMontant !== '' ? 'montant' : ''"
                        />
                    </div>
                </div>

                <div class="" v-if="this.societeList !== undefined && societeList !== []">
                    <DropDownMultiple
                        class="selectSociete"
                        :label="$t('label.bySociete')"
                        :list="societeList"
                        :listTotal="societeList"
                        :inputDisplay="this.filterSocieteDisplay"
                        :checkboxDisplay="this.societeCheckboxDisplay"
                        :selectedItems="filter.societes"
                        :isChecked="this.isCheckedSociete"
                        @add="addSelectSociete"
                        @remove="removeSelectSociete"
                        @toggleSelectAll="this.toggleSelectAll('societe')"
                        @multipleSelectSearch="multipleSelectSearchSociete"
                        :withSearch="true"
                        :drop-down-bigger="true"
                        :search="searchSociete"
                    />
                </div>

                <div class="inputWrap" v-if="filter.numeroFacture !== undefined">
                    <TextInput class="filterInput" v-model="filterNumero" :label="$t('label.filtre.facture')" />
                </div>
                <div class="" v-if="this.filter.statusList !== undefined">
                    <DropDownMultiple
                        :label="$t('label.byStatus')"
                        :list="statusList"
                        :listTotal="statusList"
                        :inputDisplay="this.filterStatusDisplay"
                        :checkboxDisplay="this.statusCheckboxDisplay"
                        :selectedItems="filter.statusList"
                        :isChecked="this.isCheckedStatus"
                        @add="addSelectStatus"
                        @remove="removeSelectStatus"
                        @toggleSelectAll="this.toggleSelectAll('status')"
                    />
                    <ReglePastille cle="facturesFournisseur.statutRejeteeExclusif" />
                    <ReglePastille cle="facturesFournisseur.filtreParDefaut" />
                </div>
                <div class="dateInputWrap" v-if="filter.factureDateFrom !== undefined">
                    <DatePicker
                        :dateValue="filter.factureDateFrom"
                        :label="$t('label.factureDateFrom')"
                        @setDate="this.setFilterFactureDateFrom"
                        :dateMax="filter.factureDateTo"
                    />
                </div>
                <div class="dateInputWrap" v-if="filter.factureDateTo !== undefined">
                    <DatePicker
                        :dateValue="filter.factureDateTo"
                        :label="$t('label.factureDateTo')"
                        @setDate="this.setFilterFactureDateTo"
                        :dateMin="filter.factureDateFrom"
                    />
                </div>
            </div>
            <div :class="getClassByCritere()" v-if="!hideButton">
                <div class="btns">
                    <ButtonWhite :onClick="clearFilter" class="clearBtn" :text="$t('button.clear')" />
                    <ButtonBlue :onClick="search" class="searchBtn" :text="$t('button.search')" />
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import ButtonBlue from '@/components/ui-components/ButtonBlue.vue';
import ButtonWhite from '@/components/ui-components/ButtonWhite.vue';
import DatePicker from '@/components/ui-components/DatePicker.vue';
import DropDownMultiple from '@/components/ui-components/DropDownMultiple.vue';
import TextInput from '@/components/ui-components/TextInput.vue';
import NumberInput from '@/components/ui-components/NumberInput.vue';
import { defineComponent } from 'vue';
import DropDown from '@/components/ui-components/DropDown.vue';
import { SocieteDTO } from '@/models/SocieteDTO';
import ReglePastille from '@/components/regles/ReglePastille.vue';

export default defineComponent({
    name: 'FilterFournisseur',
    components: { TextInput, ButtonWhite, ButtonBlue, DropDownMultiple, DatePicker, NumberInput, DropDown, ReglePastille },
    props: {
        filter: { type: Object, required: true },
        searchSociete: { type: String, required: false },
        societeList: { type: Array, required: false },
        statusList: { type: Array, required: false },
        societeListTotal: { type: Array, required: false },
        hideButton: { type: Boolean, required: false },
        hideHeader: { type: Boolean, required: false },
        comparisonList: {type: Array,  required: false},
        comparisonListFacture: {type: Array,  required: false},
    },
    methods: {
        filterSocieteDisplay(items: any[], list: any[]): string[] {
            if (items.length === list.length) return [this.$t('all')];
            return items.length > 2 ? [...items.map(x => x.libelle).slice(0, 2)] : items.map(x => x.libelle);
        },
        societeCheckboxDisplay(item: SocieteDTO): string {
            return item.libelle;
        },
        isCheckedSociete(societeDTO: SocieteDTO) {
            return !!this.$props.filter.societes.find((item: SocieteDTO) => item.id === societeDTO.id);
        },
        isCheckedStatus(status: string) {
            return !!this.$props.filter.statusList.find((item: string) => item === status);
        },
        filterStatusDisplay(items: string[], list: string[]): string[] {
            if (items.length === list.length) return [this.$t('all')];
            return items.length > 2
                ? [...items.map(x => this.$t(`state.fournisseur.${x}`)).slice(0, 2)]
                : items.map(x => {
                    return this.$t(`state.fournisseur.${x}`);
                  });
        },
        addSelectStatus(status: string): void {
            this.$emit('addFilterStatus', status);
        },
        removeSelectStatus(status: string): void {
            this.$emit('removeFilterStatus', status);
        },
        clearFilter(): void {
            this.$emit('clearFilter');
        },
        search(): void {
            this.$emit('search');
        },
        toggleSelectAll(type: string) {
            if(type === 'status'){
                this.$emit('statusToggleSelectAll');
            }
            if (type === 'societe') {
                this.$emit('societeToggleSelectAll');
            }
        },
        setFilterFactureDateFrom(value: string): void {
            this.$emit('setFactureDateFrom', value);
        },
        setFilterFactureDateTo(value: string): void {
            this.$emit('setFactureDateTo', value);
        },
        getClassByCritere(): string{
            return Object.keys(this.filter).length > 4 ? 'btnWrapper adaptive-width' : 'btnWrapper';
        },
        displayType(item: string) {
            return item;
        },
        selectComparison(value: string) : void {
            this.$emit('comparison', value);
        },
        selectComparisonFacture(value: string) : void {
            this.$emit('comparison', value);
        },
        selectType(value: string) : void {
            this.$emit('setType', value);
        },
        addSelectSociete(societe: SocieteDTO): void {
            this.$emit('addFilterSociete', societe);
        },
        removeSelectSociete(societe: SocieteDTO): void {
            this.$emit('removeFilterSociete', societe);
        },
        statusCheckboxDisplay(item: string): string {
            return this.$t(`state.fournisseur.${item}`);
        },
        multipleSelectSearchSociete(search: string) {
            this.$emit('multipleSelectSearchSociete', search);
        },
    },
    computed: {
        filterNumFactures: {
            get(): string {
                return this.$props.filter.numFactures;
            },
            set(value: string): void {
                this.$emit('setNumFactures', value);
            },
        },
        filterMontant: {
            get(): string {
                return this.$props.filter.comparisonValue;
            },
            set(value: string): void {
                this.$emit('comparisonValue', value);
            },
        },
        filterNumero: {
            get(): string {
                return this.$props.filter.numero;
            },
            set(value: string): void {
                this.$emit('setNumero', value);
            },
        },
    },
});
</script>

<style scoped>
.filter {
    padding: 8px 16px;
    background: white;
    border-radius: 6px;
    margin-bottom: 8px;
}

.filterInput {
    height: 48px;
    padding: 0 4px;
}

h2 {
    font-weight: 500;
    font-size: 18px;
    color: var(--color-principal);
    margin: 0 0 12px 0;
}

.filters {
    display: flex;
    justify-content: space-between;
}

.filterAndButtons {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-bottom: 8px;
    gap: 8px;
}

.btnWrapper {
    display: flex;
    justify-content: flex-end;
}
@media screen and (max-width: 1631px){
    .adaptive-width{
        width: 120px;
    }

}

.btns {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 8px;
    gap: 8px;
}

.clearBtn, .searchBtn {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: 1px solid var(--color-principal);
    border-radius: 4px;
    padding: 10px;
    text-transform: uppercase;
    font-weight: 600;
    max-height: 50px;
}

.clearBtn {
    background-color: white;
    color: var(--color-principal);
}

.searchBtn {
    background-color: var(--color-principal);
    color: white;
    width: 120px;
}

.noMarginLeft {
    margin-left: 0;
}

.inputWrap {
    width: 250px;
}

.dateInputWrap {
    width: 250px;
}

.selectSociete {
    width: 300px;
}
.width-250px {
    width: 250px;
}
.montant :deep(input:not(:focus):not(:valid) ~ .label) {
    height: 12px;
    top: -7px;
    font-size: var(--font-size-very-small);
}
.center {
    display: flex;
    align-items: center;
}
</style>
